export default __webpack_public_path__ + "static/media/sample-avatar.c875f14b.png";